import { type ReactNode, useCallback, useRef } from 'react';

import { CsrfContext } from './CsrfContext';

const requestCsrfToken = async (): Promise<string> => {
  try {
    const response = await fetch('/csrf_token', { headers: { 'Sec-Fetch-Dest': 'empty' } });
    if (!response.ok) return '';
    const data: unknown = await response.json();
    if (data && typeof data === 'object' && 'csrf' in data && typeof data.csrf === 'string') {
      return data.csrf;
    }
    return '';
  } catch {
    return '';
  }
};

export const CsrfProvider = ({ children }: { children: ReactNode }) => {
  const tokenRef = useRef('');
  const inflightRef = useRef<Promise<string> | null>(null);

  const ensureToken = useCallback(async () => {
    if (tokenRef.current) return tokenRef.current;

    inflightRef.current ??= requestCsrfToken().then((token) => {
      tokenRef.current = token;
      inflightRef.current = null;
      return token;
    });

    return inflightRef.current;
  }, []);

  return <CsrfContext.Provider value={ensureToken}>{children}</CsrfContext.Provider>;
};
